<template>
  <DimensionInputRenderless>
    <template v-slot="{ dimension, set, submit }">
      <div class="DimensionInput">
        <div class="my-4">
          <label for="">Width ({{ $t("market.units.length.short") }})</label>
          <div class="flex items-center justify-between mt-4">
            <input
              :value="dimension.width.min"
              @input="set('width')"
              name="min"
              type="number"
              placeholder="min"
              @keyup.enter="submit"
            />
            <span class="block mx-2">to</span>
            <input
              :value="dimension.width.max"
              @input="set('width')"
              name="max"
              type="number"
              placeholder="max"
              @keyup.enter="submit"
            />
          </div>
        </div>

        <div class="my-4">
          <label for="">Height ({{ $t("market.units.length.short") }})</label>
          <div class="flex items-center justify-between mt-4">
            <input
              :value="dimension.height.min"
              @input="set('height')"
              name="min"
              type="number"
              placeholder="min"
              @keyup.enter="submit"
            />
            <span class="block mx-2">to</span>
            <input
              :value="dimension.height.max"
              @input="set('height')"
              name="max"
              type="number"
              placeholder="max"
              @keyup.enter="submit"
            />
          </div>
        </div>

        <button class="text-center py-6 mt-4 w-full bg-grey-dark text-white" @click="submit">Apply</button>
      </div>
    </template>
  </DimensionInputRenderless>
</template>

<script>
import DimensionInputRenderless from "@/components/Listing/DimensionInputRenderless"
import { i18n } from "@/lib/vue/plugins/i18n"

export default {
  name: "Side.DimensionInput",
  components: {
    DimensionInputRenderless,
  },
}
</script>

<style scoped>
input[type="number"] {
  @apply bg-grey-lighter text-black p-4;
  outline: 0;
  width: 40%;
}
</style>
